import React, { memo } from "react";
import { Modal } from "@shopify/polaris";
import intl from "../../../../i18n/intl";
import { reqGetOrderNewShopifyArchive } from "../../../../api";

const ArchiveOrderModal = memo(
  ({ archiveOrderData, setArchiveOrderData ,getPageData,toastFun}) => {
    // 接口请求
    const handleArchiveOrder = async () => {
      setArchiveOrderData((prev) => ({ ...prev, applyLoading:true }));
      let params = {
      ids: JSON.stringify(archiveOrderData.ids),
      sids: JSON.stringify(archiveOrderData.sid),
      action:archiveOrderData.archive ? 1 : 0
    }
    try {
      let res = await reqGetOrderNewShopifyArchive(params);
      if (res.code === '200') {
        toastFun('Set Successfully') 
        getPageData()
      }
      setArchiveOrderData((prev) => ({ ...prev, open: false,applyLoading:false,split_order_list:[] }));
    } catch (error) {
      
    }
};
const textFun = ()=>{
  let text = '';
  if (archiveOrderData.archive) {
    if (archiveOrderData?.split_order_list?.length > 0){
      text = `Archiving this split order will also archive all related orders under the same master order number. Are you sure you want to continue?`
    }else {
      text = `Are you sure to archive orders?`
    }
  }else {
    if (archiveOrderData?.split_order_list?.length > 0){
      text = `Unarchiving this split order will also unarchive all related orders under the same master order number. Are you sure you want to proceed?`
    }else {
      text = `Are you sure to unarchive orders?`
    }
  }
  return text;
}
    return (
      <div>
        <Modal
          open={archiveOrderData.open}
          onClose={() => {
            setArchiveOrderData({
              open: false,
              applyLoading: false,
              archive: true,
              split_order_list:[]
            });
          }}
          title={
            archiveOrderData.archive ? "Archive orders" : "Unarchive orders"
          }
          primaryAction={{
            content: intl.get("Apply"),
            onAction: handleArchiveOrder,
            loading: archiveOrderData.applyLoading,
          }}
          secondaryActions={[
            {
              content: intl.get("Cancel"),
              onAction: () => {
                setArchiveOrderData({
                  open: false,
                  applyLoading: false,
                  archive: true,
                  split_order_list:[]
                });
              },
            }
          ]}
        >
          <Modal.Section>
            {textFun()}
          </Modal.Section>
        </Modal>
      </div>
    );
  }
);

export default ArchiveOrderModal;
